module.exports = __webpack_public_path__ + "assets/images/profile-maria_5e52e3d8c82dda640ee53e65d4b771bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-six/profile-maria.png
// module id = 225
// module chunks = 0